import { Component, OnInit } from '@angular/core';
import { QCSampleRequest } from './qc-sample-request';
import { SelectItem } from 'primeng/api';
import { QcSampleService } from './qc-sample-service';
import { Message } from 'primeng/components/common/api';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'qc-sample',
  templateUrl: './qc-sample.component.html',
  styleUrls: ['./qc-sample.component.css']
})
export class QcSampleComponent implements OnInit {
  display = false;
  enteredQCBarcode: string;
  qcSamples: SelectItem[] = [];
  msgs: Message[] = [];
  qcTypes: Map<string, string>;
  filteredQcPrimers: any[];
  qcPrimerList: SelectItem[] = [];
  qcPrimerValue: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked = false;
  isButtonClicked = false;

  constructor(private _qcSampleService: QcSampleService, private messageService: MessagesService) {

  }

  ngOnInit() {
  }

  refreshQcTypes() {
    this.qcPrimerList = [];
    this._qcSampleService.getQcPrimers().subscribe(
      results => {
        results.data.forEach(qcPrimer => {
          this.qcPrimerList.push({ label: qcPrimer.primerName, value: qcPrimer.primerName });
        })
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messageService.addErrorMessage(message);
      })
  }

  openDialog() {
    this.enteredQCBarcode = null;
    this.qcPrimerValue = null;
    this.display = true;
    this.refreshQcTypes();
  }

  isSampleEntered(): boolean {

    if (this.enteredQCBarcode != null && this.enteredQCBarcode != undefined
      && this.qcPrimerValue != null && this.qcPrimerValue != undefined) {
      return this.enteredQCBarcode.length > 0 && this.qcPrimerValue.length > 0;
    }

    return false;
  }

  registerQCSamples() {
    let qcPrimerSelected = null;
    this.display = false;
    this.blocked = true;
    this.isButtonClicked = true;
    this.qcPrimerList.forEach(qcPrimer => {
      if (qcPrimer.label === this.qcPrimerValue) {
        qcPrimerSelected = qcPrimer.value;
      }
    })

    if (qcPrimerSelected == null) {
      this.blocked = false;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: "Error", detail: "Qc Primer not found" });
    }
    else {
      let qCSampleRequest: QCSampleRequest = new QCSampleRequest(this.enteredQCBarcode, qcPrimerSelected);

      this._qcSampleService.registerQcSamples(qCSampleRequest).subscribe(
        results => {
          this.display = false;
          this.blocked = false;
          this.isButtonClicked = false;
          this.msgs = [];
          this.msgs.push({ severity: 'success', summary: 'Success', detail: 'Qc Sample Registration successful' });
        },
        error => {
          this.blocked = false;
          this.isButtonClicked = false;
          let errorMessage = error.error == null ? error.message : error.error.bbApiError == null ? error.message : error.error.bbApiError.message;
          let errorTitle = error.error == null ? error.name : error.error.bbApiError == null ? error.name : error.error.bbApiError.title;
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: errorTitle, detail: errorMessage });
        });
    }
  }
}
